import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext, useCallback } from 'react';
import { Flex } from '../Flex';
import { AccordionMainContext, AccordionSubContext } from './context';
export var AccordionHeader = function AccordionHeader(_ref) {
  var children = _ref.children,
      styleProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useContext = useContext(AccordionMainContext),
      onItemClick = _useContext.onItemClick;

  var _useContext2 = useContext(AccordionSubContext),
      id = _useContext2.id;

  var handleSelect = useCallback(function () {
    onItemClick == null ? void 0 : onItemClick(id);
  }, [id, onItemClick]);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    zIndex: 1,
    onClick: handleSelect,
    "data-test": "accordion-header-" + id
  }, styleProps), children);
};
AccordionHeader.displayName = 'AccordionHeader';